import { useWebEvents } from "./useWebEvents";
import { useEffect } from "react";
import { contentTabFramePrefix } from "../utils/constants";
const webEventType = "WEB_EVENT";
const prefixes = {
    contentTab: contentTabFramePrefix,
    modalFrame: "modal_frame",
};
export const useCatchWebEvents = () => {
    const { onWebEvent } = useWebEvents();
    useEffect(() => {
        const handler = (message) => {
            const { type } = message.data;
            if (type === webEventType && message.data.sourceIframeName) {
                const { sourceIframeName, event } = message.data;
                if (sourceIframeName.startsWith(prefixes.contentTab)) {
                    onWebEvent(event);
                }
                else if (sourceIframeName.startsWith(prefixes.modalFrame)) {
                    onWebEvent(event);
                }
            }
        };
        // Accept WebEvents from modal windows (i.e. UI2/Dialog instance)
        window.addEventListener("message", handler);
        return () => window.removeEventListener("message", handler);
    }, [onWebEvent]);
    return { onWebEvent };
};
